module.exports = __webpack_public_path__ + "img/haiwaibuju-3.bdec2cf4.png";